import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CustomerService } from '../customer.service';
import { HbmApiService } from '../hbm/hbm-api.service';
import { logError } from '../helpers/sentry.helper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerTokenGuard {
  constructor(
    private customer: CustomerService,
    private router: Router,
    private hbmService: HbmApiService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> | boolean {
    if (this.customer.isLogged) {
      return this.ensureHbmToken();
    }

    return this.restoreBeforeRedirect(state);
  }

  private async restoreBeforeRedirect(state: RouterStateSnapshot): Promise<boolean> {
    try {
      await this.customer.restoreCiamSession();
    } catch (error) {
      // Gateway ou BFF indisponible : ce n'est pas une déconnexion. Renvoyer vers AuthApp ne
      // réglerait rien, on ramène à l'accueil avec une erreur identifiable.
      logError(error);
      await this.router.navigate(['/'], { queryParams: { ciamError: 'unavailable' } });
      return false;
    }

    if (!this.customer.isLogged) {
      // Le guard ne s'exécute qu'à l'entrée de la route, jamais pendant que le client
      // travaille : rien n'est en cours d'édition, on peut repasser par AuthApp et revenir
      // exactement sur l'URL demandée.
      this.customer.login(state.url);
      return false;
    }

    return await this.ensureHbmToken();
  }

  private async ensureHbmToken(): Promise<boolean> {
    if (!environment.vendor && this.customer.userDatas?.id && !this.customer.token) {
      await this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'token');
    }

    return true;
  }
}
